import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { useTranslation } from "react-i18next";

interface InstallPromptDialogProps {
  open: boolean;
  onInstall: () => void;
  onDismiss: () => void;
}

const InstallPromptDialog: React.FC<InstallPromptDialogProps> = ({
  open,
  onInstall,
  onDismiss,
}) => {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onDismiss}>
      <DialogTitle>{t("pwa.install.title", "Установить приложение")}</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t("pwa.install.message", "Хотите установить приложение на главный экран для быстрого доступа?")}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onDismiss}>
          {t("pwa.install.dismiss", "Больше не предлагать")}
        </Button>
        <Button variant="contained" onClick={onInstall}>
          {t("pwa.install.install", "Установить")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InstallPromptDialog;
